import React, { useContext, useState } from 'react';
import { useFlags, withLDConsumer } from 'launchdarkly-react-client-sdk';
import { AppContext, isAuthorised } from '@nile/components';

function AccessControl(props) {
  const {
    roleToCheck,
    render,
    fallback,
    reference,
    ldFlag,
    flags,
    featureGateName = null,
    productToCheck = null
  } = props;
  const appContext = useContext(AppContext);
  const { currentProduct } = appContext;
  /* If the component gets productToCheck prop and the current product is not equal, return empty. */
  if (productToCheck) {
    if (productToCheck !== currentProduct) {
      return <></>;
    }
    // incase if role check is not required for IT/MSP product, just return the render comp
    if (!roleToCheck) {
      return render;
    }
  }
  const currentUserRoles = reference || appContext?.user?.role?.roleFeatureList;
  const isFeatureAuthorised = ldFlag
    ? flags[ldFlag] &&
      isAuthorised(currentUserRoles, roleToCheck, featureGateName)
    : isAuthorised(currentUserRoles, roleToCheck, featureGateName);
  if (isFeatureAuthorised) {
    return render || '';
  }
  if (fallback) return fallback;
  return '';
}

function UnauthorisedAccess(props) {
  return <div>Unauthorized access</div>;
}

const AccessControlParent = withLDConsumer()(AccessControl);

export { AccessControlParent as AccessControl, UnauthorisedAccess };
